module.exports = __webpack_public_path__ + "static/img/tupian.0d3b84bb.svg";